import { Card, CardContent } from '@xhubio-saas/core-frontend/ui-components'
import { useTranslation } from 'react-i18next'
import { ChangelogMarkdown, useChangelogSource } from './settings/changelogMarkdown'

/**
 * Changelog page — the full release changelog as its own sidebar destination
 * (bottom of the "Einstellungen" group). Relocated here from a collapsed card
 * on the Settings → System page, where the long document fought the version
 * info for space.
 *
 * The content is localized to the UI language (German languages get
 * CHANGELOG.md, everything else CHANGELOG.en.md).
 */
export function ChangelogPage() {
  const { t } = useTranslation()
  const changelogSource = useChangelogSource()

  return (
    <div className="container mx-auto py-8 px-4 space-y-6" data-testid="changelog-page">
      <h1 className="text-3xl tracking-[-0.04em]">
        {t('settings.system.changelogTitle', 'Changelog')}
      </h1>

      {/* max-w-3xl: reading measure for a long prose document — full-width
          lines are unreadable on wide screens. */}
      <Card className="w-full max-w-3xl" data-testid="changelog-content">
        <CardContent>
          <ChangelogMarkdown source={changelogSource} />
        </CardContent>
      </Card>
    </div>
  )
}
